import ErrorFormatService from '../../services/error-format-service';
import {
  GET_ASSET_LIST_DATA, GET_ASSET_LIST_DATA_SUCCESS, SAVE_ASSET_LIST_DATA, SAVE_ASSET_LIST_DATA_SUCCESS,
  SAVE_ASSET_LIST_DATA_ERROR, DELETE_ASSET_LIST_SUCCESS, DELETE_PORTFOLIO_SUCCESS, LOGIN_USER_SUCCESS,
  LOGOUT_USER_SUCCESS, GET_LIST_CONTACT_COMPANY_DATA_SUCCESS, SAVE_PORTFOLIO_ORDER_SETTINGS_SUCCESS, RESET_FORM_ERRORS,
  GET_LIST_TAG_DATA_SUCCESS,
} from '../../constants/system/actions';

const assetListReducer: Reducer = (
  state: ReducerState = {
    assetListData: null,
    formErrors: {},
    isFormSaving: false,
    isLoading: false,
  },
  action: ReduxAction,
): ReducerState => {
  switch (action.type) {
    case GET_ASSET_LIST_DATA:
      return {
        ...state,
        isLoading: action.payload && !!action.payload.page,
      };
    case GET_ASSET_LIST_DATA_SUCCESS:
      return {
        ...state,
        assetListData: action.payload && action.payload.page ? {
          ...action.data,
          assetList: [...((
            state.assetListData && state.assetListData.assetList
            && state.assetListData.assetList.map((portfolioItem: Portfolio): Portfolio => {
              const newPortfolio: Portfolio = action.data.assetList.find((newPortfolioItem: Portfolio): boolean => (
                newPortfolioItem.id === portfolioItem.id
              ));

              if (newPortfolio) {
                return {
                  ...portfolioItem,
                  assets: [
                    ...portfolioItem.assets,
                    ...newPortfolio.assets.filter((newAssetItem: Asset): boolean => (
                      !portfolioItem.assets.find((assetItem: Asset): boolean => newAssetItem.id === assetItem.id)
                    )),
                  ],
                };
              }

              return portfolioItem;
            })
          ) || []), ...(
            state.assetListData && state.assetListData.assetList
              ? action.data.assetList.filter((newPortfolioItem: Portfolio): boolean => (
                !state.assetListData.assetList.find((portfolioItem: Portfolio): boolean => (
                  newPortfolioItem.id === portfolioItem.id
                ))
              )) : action.data.assetList
          )],
        } : action.data,
        isLoading: false,
      };
    case SAVE_ASSET_LIST_DATA:
      return {
        ...state,
        formErrors: {},
        isFormSaving: true,
      };
    case SAVE_ASSET_LIST_DATA_SUCCESS:
      return {
        ...state,
        assetListData: action.data.assetListData,
        formErrors: {},
        isFormSaving: false,
      };
    case SAVE_ASSET_LIST_DATA_ERROR:
      if (!action.error) {
        return {
          ...state,
          isFormSaving: false,
        };
      }

      return {
        ...state,
        formErrors: ErrorFormatService.isFormError(action.error)
          ? ErrorFormatService.formatGraphQLErrors({ ...action.error })
          : ErrorFormatService.formatGraphQLMainError({ ...action.error }),
        isFormSaving: false,
      };
    case DELETE_ASSET_LIST_SUCCESS:
    case DELETE_PORTFOLIO_SUCCESS:
      return {
        ...state,
        assetListData: action.data.assetListData,
      };
    case GET_LIST_CONTACT_COMPANY_DATA_SUCCESS:
      if (!state.assetListData) {
        return state;
      }

      return {
        ...state,
        assetListData: {
          ...state.assetListData,
          contactCompanyList: action.data,
        },
      };
    case GET_LIST_TAG_DATA_SUCCESS:
      if (!state.assetListData) {
        return state;
      }

      return {
        ...state,
        assetListData: {
          ...state.assetListData,
          tagList: action.data,
        },
      };
    case SAVE_PORTFOLIO_ORDER_SETTINGS_SUCCESS:
      if (!action.payload || !action.payload.portfolioIds) {
        return state;
      }

      return {
        ...state,
        assetListData: {
          ...state.assetListData,
          assetList: action.payload.portfolioIds.map((portfolioId: number, portfolioIdIndex: number): Asset => ({
            ...state.assetListData.assetList.find((portfolioItem: Portfolio): boolean => (
              portfolioItem.id === portfolioId
            )),
            order: portfolioIdIndex + 1,
          })),
        },
      };
    case RESET_FORM_ERRORS:
      return {
        ...state,
        formErrors: {},
      };
    case LOGIN_USER_SUCCESS:
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        assetListData: null,
        formErrors: {},
        isFormSaving: false,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default assetListReducer;
